require('../admin/jv.Admin.Ajax.Factory');

angular.module('jv.register.service', [
        'jv.Admin.Ajax.Factory'
    ])

    .factory('jvRegistrationURLsFAC', [function () {
        var _baseUrl = '/login/action/';
        return function(key){
            var urls = {
                postRegistrationInvitationLink: 'register/invite/{0}',
                userRegistrationInfo: 'register/{0}'
            };
            return _baseUrl+urls[key];
        };
    }])

    .factory('jvRegistrationPostParams', [function () {
        return function(formObject){
            var postParams = {
                firstName: formObject['firstName'],
                lastName: formObject['lastName'],
                email: formObject['email'],
                password: formObject['password'],
                confirmPassword: formObject['confirmPassword'],
                timeZoneId: formObject['timeZoneId']
            };
            if(formObject['latitude']){
                postParams.latitude = formObject['latitude'];
                postParams.longitude = formObject['longitude'];
            }
            return postParams;
        };
    }])

    .service('jvRegistrationSVC', ['jvRegistrationURLsFAC', 'jvAjaxRequest', 'jvRegistrationPostParams',
        function (jvRegistrationURLsFAC, jvAjaxRequest, jvRegistrationPostParams) {
            this.sendInvitationLink = function(urlEId, callback, onError){
                var options = {
                    ajaxtype: 'postRegistrationInviteLink',
                    url: jvRegistrationURLsFAC('postRegistrationInvitationLink').format(urlEId),
                    requestType: 'POST',
                    headerType: 'json'
                };
                jvAjaxRequest({},options,callback, onError);
            };

            this.getRegistration = function(urlEId, callback, onError){
                var options = {
                    'ajaxtype' : 'getRegistrationUserDetails',
                    url: jvRegistrationURLsFAC('userRegistrationInfo').format(urlEId)
                };
                jvAjaxRequest({}, options, callback, onError);
            };

            this.postRegistration = function(urlEId, registrationUserInfo, callback, onError){
                var options = {
                    ajaxtype : 'postRegistrationUserDetails',
                    url: jvRegistrationURLsFAC('userRegistrationInfo').format(urlEId),
                    requestType: 'POST',
                    headerType: 'json'
                };
                jvAjaxRequest(jvRegistrationPostParams(registrationUserInfo), options, callback, onError);
            };
        }
    ]);
